import api, { API_URL, getStoredToken } from "@/lib/api";

export function mediaPublicUrl(itemOrId) {
  if (!itemOrId) return "";
  if (typeof itemOrId === "object") {
    if (itemOrId.external_url) return itemOrId.external_url;
    if (itemOrId.url && String(itemOrId.url).startsWith("http")) return itemOrId.url;
    if (itemOrId.id) return `${API_URL}/api/media/public/${itemOrId.id}`;
    return "";
  }
  return `${API_URL}/api/media/public/${itemOrId}`;
}

/** Prefer durable external URL, then authed file endpoint, then public proxy. */
export function mediaPreviewUrl(item) {
  if (!item) return "";
  if (item.external_url) return item.external_url;
  const token = getStoredToken();
  if (item.id && token) {
    return `${API_URL}/api/media/file/${item.id}?auth=${encodeURIComponent(token)}`;
  }
  return mediaPublicUrl(item);
}

export async function fetchMediaObjectUrl(item) {
  if (!item?.id) return item?.external_url || "";
  if (item.external_url) return { src: item.external_url, revoke: false };
  try {
    const { data } = await api.get(`/media/file/${item.id}`, { responseType: "blob" });
    return { src: URL.createObjectURL(data), revoke: true };
  } catch {
    if (item.external_url) return { src: item.external_url, revoke: false };
    throw new Error("Media file unavailable");
  }
}
